var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 52,
    viewBox: "0 0 40 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4865 0L21.1626 3.12948V51.8599L18.4865 48.7304V46.5235L18.4864 46.5235V43.7862L18.4865 43.7862V0ZM18.4865 3.68744L18.4863 3.68745V6.42475L18.4865 6.42474V3.68744ZM39.6489 16.9886C36.9448 10.36 31.028 5.38977 23.8386 4.02281V6.81072L23.8386 31.0713L26.5147 34.2008V7.61383C30.973 9.32813 34.6092 12.7056 36.6673 16.9886H39.6489ZM0 16.9886C2.70408 10.36 8.62087 5.38985 15.8101 4.02284V4.69432L15.8103 4.69426V39.5656L13.1341 36.4361V7.61386C8.6759 9.32817 5.03972 12.7057 2.98162 16.9886H0Z",
    fill: "url(#paint0_radial_208:285)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_208:285",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8245 25.93) rotate(90) scale(30.8477 21.1222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBB24"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.cd7d1040.svg";
export { ForwardRef as ReactComponent };